import {
  GroupByMode,
  ID,
  LifeArea,
  LocalizedLifeArea,
  noGroupingId,
  TaskGroupBy,
} from '@griply/types';

export const buildLifeAreaTaskCustomOrder = (
  groupBy: TaskGroupBy | null | undefined,
  lifeArea: LifeArea | LocalizedLifeArea | undefined,
): Record<ID, ID[]> => {
  if (!lifeArea?.id) {
    return {};
  }

  const resolved = ((): Exclude<
    GroupByMode,
    GroupByMode.None | GroupByMode.LifeArea
  > => {
    if (
      !groupBy ||
      groupBy === GroupByMode.None ||
      groupBy === GroupByMode.LifeArea
    ) {
      return GroupByMode.Section;
    }
    return groupBy as Exclude<
      GroupByMode,
      GroupByMode.None | GroupByMode.LifeArea
    >;
  })();

  if (resolved === GroupByMode.Section) {
    const sections = lifeArea.sections ?? [];
    return {
      [noGroupingId]: lifeArea.taskSorting ?? [],
      ...sections.reduce<Record<ID, ID[]>>((acc, section) => {
        acc[section.id] = section.tasks ?? [];
        return acc;
      }, {}),
    };
  }

  return lifeArea.customTaskOrder?.[resolved] ?? {};
};
